import { useState } from 'react';
import { KeyRound, Send } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from '@/components/ui/dialog';
import { toast } from 'sonner';
import api from '@/lib/api';

export default function ForgotPasswordDialog({ open, onClose }) {
  const [identifier, setIdentifier] = useState('');
  const [sent, setSent] = useState(false);
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!identifier.trim()) { toast.error("Indiquez votre identifiant ou votre email"); return; }
    setBusy(true);
    try { await api.post('/admin/forgot-password', { identifier: identifier.trim() }); setSent(true); }
    catch { toast.error("Impossible d'envoyer la demande, réessayez"); }
    finally { setBusy(false); }
  };

  return (
    <Dialog open={open} onOpenChange={(o) => { if (!o) { onClose(); setSent(false); } }}>
      <DialogContent className="sm:max-w-md" data-testid="forgot-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2"><KeyRound className="h-5 w-5 text-violet-600" /> Mot de passe oublié</DialogTitle>
          <DialogDescription>Nous enverrons un lien sécurisé (valable 1 heure) à l'adresse de récupération enregistrée dans « Mon compte ».</DialogDescription>
        </DialogHeader>
        {sent ? (
          <div className="bg-emerald-50 border border-emerald-200 rounded-xl p-4 text-sm text-emerald-800" data-testid="forgot-sent">
            Si un compte correspond, un email vient de partir. Pensez à vérifier vos courriers indésirables.
          </div>
        ) : (
          <form onSubmit={submit} id="forgot-form">
            <Label className="text-xs font-medium text-slate-500">Identifiant ou email de récupération</Label>
            <Input value={identifier} onChange={e => setIdentifier(e.target.value)} placeholder="admin ou contact@plumeetpion.fr" className="mt-1 rounded-lg" autoFocus data-testid="forgot-identifier-input" />
          </form>
        )}
        <DialogFooter>
          <Button variant="outline" className="rounded-full" onClick={() => { onClose(); setSent(false); }} data-testid="forgot-close-btn">{sent ? 'Fermer' : 'Annuler'}</Button>
          {!sent && <Button type="submit" form="forgot-form" className="rounded-full" disabled={busy} data-testid="forgot-submit-btn"><Send className="h-4 w-4 mr-2" /> {busy ? 'Envoi...' : 'Envoyer le lien'}</Button>}
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
